export default __webpack_public_path__ + "static/qrrightplain-03ab9123aaae4050ca60dde63d6dd8ee.svg";